module.exports = __webpack_public_path__ + "assets/img/box4.04ffd0be.png";